import apiClient from "../../clients/apiClient";
import API_ENDPOINTS from "../../config/apiEndpointsConfig";

export const addPlanEndpoint = async data => {
  const endpoint = API_ENDPOINTS.CREATE_PLAN();
  try {
    const response = await apiClient.post(endpoint, data);
    return response.data;
  } catch (error) {
    throw new Error(`Error posting data: ${error.message}`);
  }
};

export const deletePlanEndpoint = async planId => {
  const endpoint = API_ENDPOINTS.DELETE_PLAN(planId);
  try {
    const response = await apiClient.delete(endpoint);
    return response.data;
  } catch (error) {
    const errorMessage =
      error?.response?.data?.detail ||
      error?.response?.data?.error ||
      error.message;
    throw new Error(`${errorMessage}`);
  }
};

export const copyPlanEndpoint = async (sourcePlanId, digitalTwinId) => {
  const endpoint = API_ENDPOINTS.COPY_PLAN(sourcePlanId);
  try {
    const response = await apiClient.post(endpoint, {
      digital_twin_id: digitalTwinId,
    });
    return response.data.message;
  } catch (error) {
    throw new Error(`Error copying plan: ${error.message}`);
  }
};
